import { Injectable, InjectionToken, Inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { TenantState } from '../core/states/tenant-state/tenant.state';
import { getCurrentTenantApiUrl } from '../core/states/tenant-state/tenant.selectors';

export const APP_VERSION = new InjectionToken<string>('APP_VERSION');

/**
 * Interceptor that adds the application version to the headers of HTTP requests sent to our BE APIs.
 */
@Injectable()
export class AddAppVersionToHeadersInterceptor implements HttpInterceptor {
  private whitelist: string[] = [];

  constructor(
    @Inject(APP_VERSION) private appVersion: string,
    tenantStore: Store<TenantState>
  ) {
    tenantStore.select(getCurrentTenantApiUrl).subscribe(url => {
      this.whitelist.push(url);
    });
  }

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (this.whitelist.some(url => req.url.match(url))) {
      req = req.clone({
        setHeaders: {
          'X-App-Version': this.appVersion || 'dev'
        }
      });
    }

    return next.handle(req);
  }
}
